import { render, staticRenderFns } from "./TaskChartWidget.vue?vue&type=template&id=8da402d6&"
import script from "./TaskChartWidget.vue?vue&type=script&lang=js&"
export * from "./TaskChartWidget.vue?vue&type=script&lang=js&"
import style0 from "./TaskChartWidget.vue?vue&type=style&index=0&id=8da402d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports